export default "__VITE_ASSET__b07eab3c__"